import { useContext } from "react";

import EntityLinkGetterContext from "./EntityLinkGetterContext";

const useEntityLinkGetter = () => useContext(EntityLinkGetterContext);
export default useEntityLinkGetter;
